module.exports = __webpack_public_path__ + "static/media/system-oto-modulesD-img.49b438ec.png";